define([
  "marionette",
  "jquery",
  "messaging/messenger",
  "moment",
  "./taskWizardDenialNextStepsPageView",
  "modules/tasks/taskWizardModal/taskDenialNextSteps/taskDenialNextStepsModule",
], function (
  Marionnete,
  $,
  Messenger,
  moment,
  TaskWizardDenialNextStepsPageView,
  TaskDenialNextStepsModule,
) {
  "use strict";

  var TaskWizardDenialNextStepsPageController = Marionnete.Controller.extend({
    initialize: function (options) {
      this.region = options.region;
      this.name = "taskWizardDenialNextStepsPage";
    },
    show: function (task) {
      this.task = task;
      this.view = new TaskWizardDenialNextStepsPageView.denialNextStepsPageView({
        model: this.task,
      });
      var localeStep = task.steps().find(function (step) {
        return step.get("languageId") > 0;
      });
      // All locale-specific task steps should have the same denialNextStep, so sufficient to just grab the
      // value from the first one.
      if (localeStep) {
        this.task.localeDenialNextStep = localeStep.get("denialNextStep");
      } else {
        this.task.localeDenialNextStep = 0;
      }
      this.taskDenialNextSteps = this.addSubModule(
        new TaskDenialNextStepsModule({ region: this.view.taskDenialNextSteps }),
      );
      this.view.on("show", this._onShow, this);
      this.showRegion(this.view);
    },
    commitData: function () {
      this.view.clearErrors();
      this.task.set({
        description: this.view.getTaskDescription(),
        name: this.view.getTaskName(),
      });
      this.taskDenialNextSteps.commitData();
      var localeDenialNextStep = this.view.getLocaleDenialNextStep();
      this.task.steps().each(function (step) {
        if (step.get("languageId") > 0) {
          step.set("denialNextStep", localeDenialNextStep);
        }
      }, this);
      if (!this.task.get("name")) {
        this.view.nameError($.t("commonMessages.emptyMessage"));
        return false;
      }
      if (!this.task.get("description")) {
        this.view.descriptionError($.t("commonMessages.emptyMessage"));
        return false;
      }
      return true;
    },
    _onShow: function () {
      this.taskDenialNextSteps.show(this.task);
    },
  });

  return TaskWizardDenialNextStepsPageController;
});
